const messages = {
    addPaymentMethods: 'Añadir Método de Pago',
    paymentTypeId: 'Tipo de Pago',
    paymentType: 'Tipo de Pago',
    paymentsByProvider: 'Pagos Pensuales a Proveedores',
    moneyCollectionPerDay: 'Estadísticas de Cobros',
    graphMoneyCollectionPerDay: 'Operaciones de Cobro por Día',
    numberMoneyCollectionPerDay: 'Monto de Cobros por Día',
    companyLegalDataEditedSuccessfully: 'Información Legal de la Compañía Actualizada Exitosamente',
    companyLegalDataNote: 'Ésta Información es necesaria para algunos documentos de pagos',
    companyLegalDataAlert: 'Ésta información es requerida por documentos de pagos',
    companyLegalData: 'Datos Legales de la Empresa',
    confirmDeletePaymentMethod: 'Confirmar Eliminación del Método de Pago',
    unauthorizedAction: 'Usted no tiene autorización para realizar ésta acción',
    unauthorizedStatistics: 'Usted no tiene autorización para ver éstas estadísticas',
    unauthorizedPaymentsStatistics: 'Usted no tiene autorización para ver estadísticas de pago',
    unauthorizedPaymentsList: 'Usted no tiene autorización para ver la lista de pagos',
    unauthorizedPaymentsTypesList:
        'Usted no tiene autorización para ver la lista de tipos de pagos',
    unauthorizedEditCompanyLegalData:
        'Usted no tiene autorización para editar los datos de la compañía',
    unauthorizedBalanceAdjustmentsList:
        'Usted no tiene autorización para ver la lista de ajustes de balance',
    unauthorizedBalanceAdjustmentsHistory:
        'Usted no tiene autorización para ver el historial de ajustes de balance',
    unauthorizedCreateBalanceAdjustments:
        'Usted no tiene autorización para crear ajustes de balance',
    addExternalProvider: 'Adicionar Proveedor Externo',
    editExternalProvider: 'Editar Proveedor Externo',
    checkNumber: 'Número de Cheque',
    youWantToRemoveExternalProvider: 'Desea eliminar el Proveedor externo',
    unauthorizedCreateLockPatient: 'Usted no tiene autorización para bloquear pacientes',
    quoteLogs: 'Registros de Cuota',
    modifiedBy: 'Modificado',
    QuoteTransfers: 'Transferencias de Cuota',
    TreatmentTransfers: 'Transferencias de Tratamientos',
    allTreatmentTransfers: 'Todas las transferencias de los tratamientos',
    manualCheck: 'Cheque Manual',
    createManualProviderCheck: 'Crear Cheque Manual del Proveedor',
    manualCheckCreatedSuccessfully: 'Cheque manual del proveedor creado exitosamente',
    memo: 'Memo',
    amountMustBeGreaterThanZero: 'El monto debe ser mayor que cero',
    memoIsRequired: 'El memo es obligatorio',
    providerPaymentHistory: 'Historial de pagos del proveedor',
    paymentHistoryRows: 'pagos',
    period: 'Periodo',
    payDate: 'Fecha de pago',
    paymentPeriodStartDate: 'Fecha de inicio del periodo de pago',
    paymentPeriodEndDate: 'Fecha de fin del periodo de pago',
    paymentPeriodStartDateRequired: 'La fecha de inicio del periodo de pago es obligatoria.',
    paymentPeriodEndDateRequired: 'La fecha de fin del periodo de pago es obligatoria.',
    paymentPeriodEndOnOrAfterStart:
        'La fecha de fin del periodo de pago debe ser igual o posterior a la fecha de inicio.',
    source: 'Origen',
    printStatus: 'Estado de impresión',
    printed: 'Impreso',
    unpublished: 'No publicado',
    errorLoadingPaymentHistory: 'Error al cargar el historial de pagos del proveedor',
    unauthorizedPaymentHistory:
        'Usted no tiene autorización para ver el historial de pagos del proveedor',
    // Invoice-link column (US #1808/#1809)
    linkedInvoice: 'Factura de respaldo',
    noInvoiceLinked: '— Sin factura —',
    linkInvoice: 'Vincular factura',
    changeInvoice: 'Cambiar factura',
    removeInvoice: 'Quitar',
    invoiceLinkedSuccessfully: 'Factura vinculada exitosamente',
    invoiceUnlinkedSuccessfully: 'Factura desvinculada exitosamente',
    errorUpdatingInvoiceLink: 'Error al actualizar el vínculo de la factura',
};

export default messages;
